// pages/index.js or pages/exports.js

import { lazy } from "react";

const AdminDashboard = lazy(() => import("./AdminDashboard"));
const AdminCourses = lazy(() => import("./AdminCourses"));
const AdminStaff = lazy(() => import("./AdminStaff"));
const AdminDepartments = lazy(() => import("./Departments"));
const AdminBranches = lazy(() => import("./AdminBranches"));
const AdminSchoolCharges = lazy(() => import("./AdminSchoolCharges"));
const AdminCashFlow = lazy(() => import("./AdminCashFlow"));
const AdminIncomeStatement = lazy(() => import("./AdminIncomeStatement"));
const AdminBalanceSheet = lazy(() => import("./AdminBalanceSheet"));

export {
  AdminDashboard,
  AdminCourses,
  AdminStaff,
  AdminDepartments,
  AdminBranches,
  AdminSchoolCharges,
  AdminCashFlow,
  AdminIncomeStatement,
  AdminBalanceSheet,
};
